import { Controller, useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { X } from "@phosphor-icons/react"
import { Button } from "@/components/ui/button"
import { ScrollArea } from "@/components/ui/scroll-area"
import { LabelAndSelectValue, Select, SelectContent, SelectItem, SelectTrigger } from "@/components/ui/select"
import { getDeBetterDocSubSpecialties } from "@/modules/patients/detail/better-doc/de/lib/de-better-doc-sub-specialties"
import type { DeBetterDocSearchFormType } from "@/modules/patients/detail/better-doc/de/schema/de-better-doc-search-schema"
import type { BetterDocSpecialty } from "@/modules/patients/detail/better-doc/lib/better-doc-sub-specialties"

export const DeBetterDocSubSpecialtySelect = ({ specialtyName }: { specialtyName: BetterDocSpecialty }) => {
  const { t } = useTranslation()
  const { control } = useFormContext<DeBetterDocSearchFormType>()

  const subSpecialties = getDeBetterDocSubSpecialties(specialtyName)

  if (subSpecialties.length === 0) {
    return null
  }

  return (
    <div className="w-full">
      <Controller
        control={control}
        name="subSpecialty"
        render={({ field: { value, onChange } }) => (
          <div className="relative">
            <Select value={value} onValueChange={onChange}>
              <SelectTrigger data-testid="sub-specialty-select-trigger">
                <LabelAndSelectValue
                  label={t("episodeOfCare.betterDoc.searchDialog.subSpecialty")}
                  value={value ? t(`episodeOfCare.betterDoc.searchDialog.subSpecialties.${value.toUpperCase()}`) : ""}
                />
              </SelectTrigger>
              <SelectContent className="max-w-(--radix-select-trigger-width)">
                <ScrollArea className="max-h-64">
                  <div className="py-2">
                    {subSpecialties.map((option) => (
                      <SelectItem key={option} value={option} data-testid={`sub-specialty-option-${option}`}>
                        {t(`episodeOfCare.betterDoc.searchDialog.subSpecialties.${option.toUpperCase()}`)}
                      </SelectItem>
                    ))}
                  </div>
                </ScrollArea>
              </SelectContent>
            </Select>
            {value && (
              <Button
                variant="circle"
                className="absolute top-1/2 right-10 h-10 w-10 -translate-y-1/2"
                onClick={(event) => {
                  event.preventDefault()
                  event.stopPropagation()
                  onChange(undefined)
                }}>
                <X />
              </Button>
            )}
          </div>
        )}
      />
    </div>
  )
}
